import { AllowedAccess } from "react-permission-role"
import { FormCalculadorEnganche } from './FormCalculadorEnganche'

const CalculadorEnganche = () => {
    return (
        <AllowedAccess permissions={['158_CALCULADOR_DE_ENGANCHE']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                <div id="formularioregistros">
                    <FormCalculadorEnganche />
                </div>
            </div>
        </AllowedAccess>
    )
}

export {
    CalculadorEnganche
}